// NotFound.js
import React from "react";
const NotFound = () => {
  return (
    <div className="all-center">
      <h1 className="x-large text-danger">404 - Page Not Found</h1>
      <p className="lead">
        Sorry, the page you are looking for does not exist.
      </p>
    </div>
  );
};
export default NotFound;
